import React from "react"

import * as styles from "./Spinner.module.scss"

const spinner = () => <div className={styles.Loader}>Loading...</div>

export default spinner
